export function UploadFiles(client) {
    return {
        get(masterAccountId, uploadSetId, uploadFileId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}`);
        },
        getAll(masterAccountId, uploadSetId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files`);
        },
        put(masterAccountId, uploadSetId, uploadFileId, data) {
            return client.put(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}`, data);
        },
        post(masterAccountId, uploadSetId, data) {
            return client.post(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files`, data);
        },
        download(masterAccountId, uploadSetId, uploadFileId) {
            return client.get(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}/download`, { responseType: 'arraybuffer' });
        },
        delete(masterAccountId, uploadSetId, uploadFileId, removeChildren) {
            return client.delete(`/accounts/${masterAccountId}/upload-sets/${uploadSetId}/upload-files/${uploadFileId}?removeChildren=${removeChildren}`);
        }
    };
}
